import { render } from "./Android.vue?vue&type=template&id=013c506a"
import script from "./Android.vue?vue&type=script&lang=js"
export * from "./Android.vue?vue&type=script&lang=js"

import "./Android.vue?vue&type=style&index=0&id=013c506a&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__